import { render } from "./ConfirmationModal.vue?vue&type=template&id=3e90e1aa&ts=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__